import PropTypes from "prop-types";
import Image from "next/image";
import "../../styles/scss/customer.module.scss";
import "./styles/_home-page-customer.module.scss";

const TrustedCompaniesV2 = (props: { className: string, paragraph?: string}) => {

    const imageGroup = [
        {
            image: "/images/v2/customer-logos/corgi-logo.svg",
            alt: "Corgi",
            className: "corgi-logo mr-bottom"
        },
        {
            image: "/images/v2/customer-logos/ceat.svg",
            alt: "Ceat",
            className: "ceat-logo mr-bottom"
        },
        {
            image: "/images/v2/customer-logos/dr-reddy-logo.svg",
            alt: "Dr.Reddy's",
            className: "wrangler-logo mr-bottom"
        },
        {
            image: "/images/v2/customer-logos/eragon.svg",
            alt: "eragon",
            className: "hoichoi-logo mr-bottom"
        },
        {
            image: "/images/v2/customer-logos/hoichoi.svg",
            alt: "hoichoi",
            className: "awign-logo mr-bottom"
        },
        {
            image: "/images/v2/customer-logos/hellyeah.svg",
            alt: "Hellyeah",
            className: "hoichoi-logo mr-bottom"
        },
        {
            image: "/images/v2/customer-logos/lee.svg",
            alt: "Lee",
            className: "lee-logo mr-bottom"
        },
        {
            image: "/images/v2/customer-logos/wrangler.svg",
            alt: "Wrangler",
            className: "wrangler-logo mr-bottom"
        },
        {
            image: "/images/v2/customer-logos/zoop.svg",
            alt: "Zoop",
            className: "hoichoi-logo"
        },
        {
            image: "/images/v2/customer-logos/effigo-logo.svg",
            alt: "Effigo",
            className: "ceat-logo"
        },
        // {
        //     image: "/images/v2/customer-logos/bolna.svg",
        //     alt: "Bolna",
        //     className: "bolna-logo"
        // },
        // {
        //     image: "/images/v2/customer-logos/cluster.svg",
        //     alt: "Cluster",
        //     className: "cluster-logo"
        // },
        {
            image: "/images/trusted-company/hotplate.svg",
            alt: "Hotplate",
            className: "hotplate-logo"
        },
        {
            image: "/images/trusted-company/revenium.svg",
            alt: "Revenium",
            className: "revenium-logo"
        },
        {
            image: "/images/v2/customer-logos/finfactor.svg",
            alt: "FinFactor",
            className: "hotplate-logo"
        },
        {
            image: "/images/v2/customer-logos/awign.svg",
            alt: "Awign",
            className: "awign-logo"
        },
        {
            image: "/images/v2/customer-logos/pl-capital.svg",
            alt: "PL Capital",
            className: "hoichoi-logo"
        },
        // {
        //     image: "/images/v2/customer-logos/g-star.svg",
        //     alt: "G-Star",
        //     className: "g-star-logo"
        // },
        {
            image: "/images/v2/customer-logos/attend.svg",
            alt: "Attend",
            className: "attend-logo"
        },
        // {
        //     image: "/images/v2/customer-logos/jets-com.svg",
        //     alt: "Jets.com",
        //     className: "jets-com-logo"
        // },
        {
            image: "/images/v2/customer-logos/wellness-360.svg",
            alt: "Wellness 360",
            className: "wellness-360-logo"
        },
        // {
        //     image: "/images/v2/customer-logos/simplification.svg",
        //     alt: "Simplification",
        //     className: "simplification-logo"
        // }
        
    ]

    return (
        <>
            <div className={`customer-trust ${props.className || ""}`}>
                <div className={"container"}>

                    <div className={"our-trusted"}>
                        {props.paragraph && <p>{props.paragraph}</p>}
                        <div className={"d-flex"}>

                            {
                                imageGroup.map((img) => {
                                    return <Image
                                        key={img.alt}
                                        src={img.image}
                                        alt={img.alt}
                                        width={98}
                                        height={98}
                                        loading="lazy"
                                        className={img.className || ""}
                                    />
                                })
                            }


                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

TrustedCompaniesV2.defaultProps = {
    className: "",
    paragraph: ""
}

TrustedCompaniesV2.propTypes = {
    className: PropTypes.string,
    paragraph: PropTypes.string
}

export default TrustedCompaniesV2;